import { render, staticRenderFns } from "./paragraph-preview.vue?vue&type=template&id=39a7239d&scoped=true&"
import script from "./paragraph-preview.vue?vue&type=script&lang=js&"
export * from "./paragraph-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a7239d",
  null
  
)

export default component.exports